import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_LML } from "app/auth/baseAsapLml";
import moment from "moment";
import constants from "@tracking/utils/constants";

const { DATE_FORMAT } = constants;

const parseGetFiliaisTransportadoras = (params) => {
  return {
    dataInicial: moment(params.dataInicial).format(DATE_FORMAT.API),
    dataFinal: moment(params.dataFinal).format(DATE_FORMAT.API),
    statusColetaRoteiros: params.statusColetaRoteiros,
    tipoRoteiros: params.tipoRoteiros,
  };
};

const parseGetRoteirosAlertas = (params) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasIds: params.transportadorasIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    statusColetaRoteiros: params.statusColetaRoteiros,
    tipoRoteiros: params.tipoRoteiros,
  };
};

const parseGetRoteirosCriticidade = (params: any) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasIds: params.transportadorasIds,
    dataRoteiros: moment(params.dataRoteiros).format(DATE_FORMAT.API),
    tipoCriticidade: params.tipoCriticidade,
    statusColetaRoteiros: params.statusColetaRoteiros,
    tipoRoteiros: params.tipoRoteiros,
  };
};

export const getFiliaisTransportadoras = createAsyncThunk(
  "torreLmlApp/torreLml/getFiliaisTransportadoras",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get(
        "/dashboard/roteiros/LML/pedidos/filiaisetransportadoras",
        {
          params: parseGetFiliaisTransportadoras(params),
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraDiaEvolucao = createAsyncThunk(
  "torreLmlApp/torreLml/getSafraDiaEvolucao",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get("/dashboard/safra/dia/LML/evolucao", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getSafraPlanejada = createAsyncThunk(
  "torreLmlApp/torreLml/getSafraPlanejada",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get("/dashboard/safra/dia/LML/planejado", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosAlertas = createAsyncThunk(
  "torreLmlApp/torreLml/getRoteirosAlertas",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get("/dashboard/roteiros/LML/alertas", {
        params: parseGetRoteirosAlertas(params),
        paramsSerializer: {
          indexes: null,
        },
      });
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao exibir filiais e transportadoras",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosCriticidade = createAsyncThunk(
  "torreLmlApp/torreLml/getRoteirosCriticidade",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get(
        "/dashboard/roteiros/LML/criticidades",
        {
          params: parseGetRoteirosCriticidade(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      // dispatch(
      //   openModalError({
      //     title: "Erro ao buscar criticidades dos roteiros",
      //     text: "Verifique se os dados digitados estão corretos!",
      //     btnLabel: "Voltar",
      //   })
      // );
      console.error(err.response);
    }
    return response.data;
  }
);
